import React from "react";
import {useSite} from "../../context/SiteContext";

export const mailHref = (email) => 'mailto:' + email;
export const telHref = (phone) => 'tel:' + phone.replace(/[^\d+]/g, '');

// Text with {email} and {phone} placeholders, filled in from the admin settings as links.
const ContactText = ({text}) => {
    const {settings} = useSite();
    return String(text).split(/(\{email\}|\{phone\})/).map((part, i) => {
        if (part === '{email}') return <a key={i} href={mailHref(settings.email)}>{settings.email}</a>;
        if (part === '{phone}') return <a key={i} href={telHref(settings.phone_number)}>{settings.phone_number}</a>;
        return part;
    });
};

export default ContactText;
